namespace GeniuzPOS.QRreport {
    export interface QRywcSpecReportCusStockOnHandForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        ShopId: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        SupplId: Serenity.LookupEditor;
        SkuCode: Serenity.LookupEditor;
    }

    export class QRywcSpecReportCusStockOnHandForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpecReportCusStockOnHand';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpecReportCusStockOnHandForm.init)  {
                QRywcSpecReportCusStockOnHandForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(QRywcSpecReportCusStockOnHandForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'ShopId', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'SupplId', w0,
                    'SkuCode', w0
                ]);
            }
        }
    }
}
